__turbopack_context__.v({
  "average": "dRE3yq_average",
  "compact": "dRE3yq_compact",
  "inverse": "dRE3yq_inverse",
  "label": "dRE3yq_label",
  "separator": "dRE3yq_separator",
  "star": "dRE3yq_star",
  "summary": "dRE3yq_summary",
});
